<template>
  <div
:id="uniqueId" v-if="dontGotIt || !messageKey"
    :class="arrayToObject(classes, k => k, v => true)"
    class="top-message">
      <template v-if="title">
        <h3>
          <template v-if="titleIcon">
            <font-awesome-icon :icon="titleIcon" />&nbsp;
          </template>
          {{ title }}
        </h3>
      </template>
      <span class="message"><slot></slot></span>
      <button
class="btn btn-link inline"
        @click="handleGotIt">
        {{ gotItButtonText }}
      </button>
  </div>
</template>

<script>
import _ from 'lodash';

import { UserSettings } from 'assets/js/usersettings';

export default {
  name: 'top-message',

  components: {},

  computed: {
    userSettingsKey() {
      // Put top message helpboxes into their own namespace.
      return `top-message-${this.messageKey}`;
    },
  },

  created() {
    this.uniqueId = this.uuid4();
    if (this.idOverride) this.uniqueId = this.idOverride;
  },

  data() {
    return {
      dontGotIt: false,
      isShowing: this.showByDefault,
      uniqueId: null,
      userSettings: UserSettings(this.$store),
    };
  },

  methods: {
    handleGotIt() {
      this.userSettings.HelpBoxes.put(this.userSettingsKey, false);
      this.isShowing = false;
      this.dontGotIt = false;
    },

  },

  async mounted() {
    if (!this.messageKey) return;

    let dontGotIt = await this.userSettings.HelpBoxes.get(this.userSettingsKey);
    if (_.isUndefined(dontGotIt)) dontGotIt = true;
    this.dontGotIt = dontGotIt;
    await this.$nextTick();
  },

  props: {
    // Arrays
    classes: {
      type: Array,
      default: () => [],
    },

    // Booleans
    showByDefault: {
      type: Boolean,
      default: true,
    },

    // Objects

    // Strings
    gotItButtonText: {
      type: String,
      default: 'Hide this message',
    },
    messageKey: { // Make sure this is unique!
      type: String,
      required: true,
    },
    idOverride: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    titleIcon: {
      type: Object,
      required: false,
    },
  },
};
</script>

<style scoped lang="scss">
  @import "~assets/css/buttons";
  @import "~assets/css/colors";

  .top-message {
    background: rgb(6,25,93);
    background: radial-gradient(circle,
      rgba(6,25,93,1) 0%, rgba(131,40,218,1) 100%);
    color: #FFFFFF;

    padding: 0.4em 1em;

    -webkit-box-shadow: 0px 3px 5px 3px rgba(0,0,0,0.5);
    -moz-box-shadow: 0px 3px 5px 3px rgba(0,0,0,0.5);
    box-shadow: 0px 3px 5px 3px rgba(0,0,0,0.5);

    h3 {
      font-size: 1.4rem;
      font-weight: bold;
      margin-bottom: 0.5rem;
    }

    .btn-link {
      color: #FFFFFF !important;
    }

    .message {
      display: block;
      max-width: 50em;
    }
  }
</style>
